import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private http: HttpClient) { }

  GetNotifications(params: any) {
    return this.http.get(`${environment.apiUrl}/Notification/list`, { params });
  }
  SeeNotifications(params: any) {
    return this.http.get(`${environment.apiUrl}/notification/SeeNotifications`, { params });
  }

  getNotificationSettings() {
    return this.http.get(`${environment.apiUrl}/Notification/GetNotificationSettings`);
  }

  updateNotificationSettings(data: any) {
    return this.http.post(`${environment.apiUrl}/Notification/UpdateNotificationSettings`, data);
  }
}
